import { useSelector } from 'react-redux';
import { RootState } from '../reduxStore/Store';
import { parseOptionValue } from '../reduxStore/OptionSlice';

/**
 * Lit une option avec résolution automatique dept → tenant → default.
 * Le département actif (AppSlice.selectedDepartement) est pris en compte
 * si les options du dept ont été chargées en Redux.
 *
 * Usage :
 *   const autoPrint    = useOption<boolean>('pos.auto_print', false);
 *   const tvaDefaut    = useOption<number>('facturation.tva_default', 18);
 *   const headerTicket = useOption<string>('pos.ticket_header_text', '');
 */
export function useOption<T = any>(key: string, fallback?: T): T {
  const { optionsTenant, optionsDept, currentDeptId } = useSelector(
    (state: RootState) => state.OptionSlice
  );
  const selectedDept = useSelector((state: RootState) => state.AppSlice.selectedDepartement);

  // Si le dept actif correspond à la vue chargée → on utilise optionsDept (cascade déjà résolue)
  const useDeptView = selectedDept?.id && selectedDept.id === currentDeptId;
  const source = useDeptView ? optionsDept : optionsTenant;

  const opt = source.find((o) => o.option_key === key);
  if (!opt) return fallback as T;
  return parseOptionValue<T>(opt.option_value, opt.option_type, fallback);
}
